import { useCallback as e, useLayoutEffect as t, useRef as n, useState as r } from "react";
//#region src/hooks/useResizeObserver.ts
var i = (e) => {
	let t = e?.borderBoxSize?.at(0);
	return {
		blockSize: t?.blockSize ?? e?.contentRect.height,
		inlineSize: t?.inlineSize ?? e?.contentRect.width
	};
}, a = (a) => {
	let [o, s] = r(null), c = n(null), l = n(null), u = e(() => l.current?.disconnect(), []), d = e(() => {
		l.current = new ResizeObserver(([e]) => {
			s((t) => {
				if (!t) return e;
				let n = i(t), r = i(e);
				return t.target === e.target && n.blockSize === r.blockSize && n.inlineSize === r.inlineSize ? t : e;
			});
		});
		let e = a ?? c.current;
		e && l.current.observe(e);
	}, [a]);
	t(() => (u(), d(), () => u()), [u, d]);
	let f = i(o);
	return [
		c,
		o,
		{
			blockSize: f.blockSize,
			inlineSize: f.inlineSize
		}
	];
};
//#endregion
export { a as default };

//# sourceMappingURL=useResizeObserver.js.map